import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaidRoundedIcon from "@mui/icons-material/PaidRounded";
import RowContainer from "../../../../common/RowContainer";
import UserProjectsList from "./UserProjectsList";
import ColumnContainer from "../../../../common/ColumnContainer";
import { TableWrapper, TitleContainer } from "../../../style";
import {
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Pagination,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { CopyAllRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import { DashboardButton } from "../../../../common/DashboardButton";

import { useUpdateSingleUserMutation } from "../../../../../redux/features/usersManagement/usersManagementApi";
import { useGetUserByUserIdQuery } from "../../../../../redux/features/usersManagement/usersManagementApi";
import Loading from "../../../../loading/LoadingPage";
import { getUserDetails } from "../../../../../redux/features/usersManagement/usersManagementSlice";
import {
  changePageNumberProjects,
  getProjects,
  selectUserProjects,
} from "../../../../../redux/features/projects/projectsSlice";
import { adminDashboardRoute } from "../../../../../utils/routes/Routes";
import CreditsModal from "./CreditsModal";
import "../UserStyle.less";
import SelectComponent from "../../../../common/SelectComponent";
import { SnackbarComponent } from "../../../../common/SnackbarComponent";
import { useGetProjectsByUserIdQuery } from "../../../../../redux/features/projects/projectsApi";
import { FormatDateTime } from "../../../../../utils/helpers/FormatDateTime";
import { SkeletonLoading } from "../../../../common/SkeletonLoading";
import { ErrorLoading } from "../../../../common/ErrorLoading";

export const SingleUserPage = () => {
  // INIT
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { projectId } = useParams();

  // STATE
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    project_status: null,
    brand: null,
    model: null,
    vehicle_type: null,
    modified_at: null,
    created_at: null,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [userCardOpen, setUserCardOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(false);
  const [sentPassword, setSentPassword] = useState(false);
  const [userStatus, setUserStatus] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  // REDUX
  const {
    data: initialData,
    isLoading: initialIsLoading,
    isError: initialIsError,
    refetch: refetchSingleUser,
  } = useGetUserByUserIdQuery(id, {
    skip: !id,
  });

  // const pageNumber = useSelector(selectUserProjects);
  const pageNumber = 1;

  const {
    data: projects,
    isLoading: isLoadingProjects,
    isError: isErrorProjects,
    refetch: refetchSlaveProjects,
  } = useGetProjectsByUserIdQuery(
    {
      userId: id,
      page: currentPage,
      queryFilters: filters,
    },
    { skip: !id }
  );
  const [updateUser, { isLoading: uploadIsLoading }] =
    useUpdateSingleUserMutation();

  // EFFECTS
  useEffect(() => {
    refetchSlaveProjects(id);
  }, [id, refetchSlaveProjects, location.pathname]);

  useEffect(() => {
    if (projects && !isLoadingProjects && !isErrorProjects) {
      dispatch(getProjects(projects));
    }
  }, [
    projects,
    pageNumber?.pagination?.activePage,
    isLoadingProjects,
    isErrorProjects,
    dispatch,
  ]);

  useEffect(() => {
    if (initialData && !initialIsLoading && !initialIsError) {
      dispatch(getUserDetails(initialData));
    }
  }, [initialData, initialIsLoading, dispatch, initialIsError]);

  // UTILS
  const headers = [
    // "ID",
    <FormattedMessage id="table.header.status" />,
    <FormattedMessage id="table.header.type" />,
    <FormattedMessage id="table.header.brand" />,
    <FormattedMessage id="table.header.model" />,
    <FormattedMessage id="table.header.created" />,
    <FormattedMessage id="table.header.updated" />,
    <FormattedMessage id="table.header.details" />,
    <FormattedMessage id="table.header.actions" />,
  ];

  const titles = [
    { id: "Id" },
    { admin_id: "Admin Id" },
    { last_name: <FormattedMessage id="register.form.lastname" /> },
    { first_name: <FormattedMessage id="register.form.firstname" /> },
    { company_name: <FormattedMessage id="register.form.company" /> },
    { address: <FormattedMessage id="register.form.address" /> },
    { city: <FormattedMessage id="register.form.city" /> },
    { zip_code: <FormattedMessage id="register.form.zip" /> },
    { country: <FormattedMessage id="register.form.country" /> },
    { vat_number: <FormattedMessage id="register.form.vat" /> },
    { phone: <FormattedMessage id="register.form.phone" /> },
    { email: <FormattedMessage id="register.form.email" /> },
    { status: <FormattedMessage id="users.status" /> },
    { credits: <FormattedMessage id="credits" /> },
  ];

  const today = new Date().toLocaleDateString("IT-GB");
  const data = initialData;

  // FUNCTIONS
  const handleReloadProjectList = async (user_id) => {
    setDisabledBtn(true);
    try {
      await refetchSlaveProjects(user_id);
      setTimeout(() => {
        setDisabledBtn(false);
      }, 2000);
    } catch (error) {
      console.error("Error reloading project list:", error);
      setDisabledBtn(false);
    }
  };

  const handleUserCardOpen = () => {
    setUserCardOpen(!userCardOpen);
  };

  const handleFiltersChange = (filters) => {
    setFilters(filters);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    dispatch(changePageNumberProjects(value));
  };

  const handlePageChange2 = (value) => {
    setCurrentPage(value);
  };

  const handleCurrentPageChange = (value) => {
    setCurrentPage(value);
  };

  const handleGoBackToUsers = () => {
    navigate(adminDashboardRoute.users);
  };

  const handleUserStatusChange = (event) => {
    event.preventDefault();
    setUserStatus(event.target.value);
    setEditingUser(true);
  };

  const handleCancel = () => {
    setEditingUser(false);
    setUserStatus(null);
  };

  const handleSaveUser = async (userId) => {
    const objectToSave = {
      status: userStatus,
    };
    try {
      const result = await updateUser({
        userId,
        ...objectToSave,
      }).unwrap();
      if (result) {
        setEditingUser(false);
      }
    } catch (error) {
      console.error("Failed to update user:", error);
    }
  };

  const handleSendPassword = () => {
    // chiamata api per inviare la password, restituisce sent: true e updated_at
    // in questo caso sent === true gestito da un local state
    setSentPassword(true);
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setOpenSnackbar(true);
    } catch (err) {
      return false;
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <ColumnContainer style={{ height: "100vh" }}>
      {projectId ? (
        <Outlet />
      ) : initialIsLoading || isLoadingProjects ? (
        <SkeletonLoading />
      ) : initialIsError || isErrorProjects ? (
        <ErrorLoading />
      ) : data ? (
        <ColumnContainer padding="20px 0 0 0">
          <RowContainer align="center">
            <TitleContainer className="sticky">
              <RowContainer start align="center">
                <RowContainer minGap start align="center">
                  <IconButton>
                    <ArrowBackIosRoundedIcon
                      fontSize="small"
                      onClick={handleGoBackToUsers}
                    />
                  </IconButton>
                  <Typography variant="h3" component="h3">
                    <FormattedMessage id="users.singleUser" /> #{id} -{" "}
                    {data?.first_name} {data?.last_name}{" "}
                  </Typography>
                </RowContainer>
              </RowContainer>
            </TitleContainer>
            <RowContainer
              start
              align="start"
              minGap
              onClick={handleUserCardOpen}
            >
              <Typography
                variant="p"
                component={"p"}
                sx={{
                  color: "var(--main-color)",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <FormattedMessage id="users.userData" />
              </Typography>
              <IconButton
                sx={{
                  backgroundColor: "var(--bkg-quaternary)",
                }}
              >
                <KeyboardArrowDownRounded
                  sx={{
                    "& path": { color: "var(--main-color)" },
                    cursor: "pointer",
                    transform: userCardOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </IconButton>
            </RowContainer>
          </RowContainer>
          <ColumnContainer>
            <>
              {userCardOpen ? (
                <ColumnContainer>
                  <TableWrapper
                    className="projects-details-table"
                    style={{
                      backgroundColor: "var(--bkg-primary",
                      padding: 20,
                      borderRadius: "12px",
                    }}
                  >
                    <Grid container spacing={2} columnSpacing={6}>
                      {titles.map((item, index) => {
                        const key = Object.keys(item)[0];
                        const value = data[key];
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            height="fit-content"
                            key={index}
                          >
                            <ColumnContainer minGap>
                              <Typography
                                variant="h6"
                                component="h6"
                                fontSize="1rem"
                                fontWeight="bold"
                                color={"var(--main-color)"}
                              >
                                {Object.values(item)[0]}
                              </Typography>
                              <RowContainer align="center">
                                <Typography
                                  variant="p"
                                  component="p"
                                  sx={{ cursor: "default" }}
                                >
                                  {value ? value : "-"}
                                </Typography>
                                {key === "credits" ? (
                                  <DashboardButton
                                    type="filled"
                                    onClick={handleOpenModal}
                                  >
                                    <RowContainer center align="center" minGap>
                                      <FormattedMessage id="button.add" />
                                      <PaidRoundedIcon />
                                    </RowContainer>
                                  </DashboardButton>
                                ) : null}
                              </RowContainer>

                              <Divider
                                sx={{
                                  borderColor: "#f5f5f5",
                                }}
                              />
                            </ColumnContainer>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </TableWrapper>
                </ColumnContainer>
              ) : null}
              <Grid container spacing={2} columnSpacing={6}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <ColumnContainer minGap>
                    <Typography
                      variant="h6"
                      component="h6"
                      fontSize="1rem"
                      fontWeight="bold"
                      color={"var(--main-color)"}
                    >
                      <FormattedMessage id="users.updateStatus" />
                    </Typography>

                    <SelectComponent
                      value={userStatus || data?.status}
                      onChange={(event) => handleUserStatusChange(event)}
                    >
                      <MenuItem value="banned">
                        {" "}
                        <FormattedMessage id="status.banned" />
                      </MenuItem>
                      <MenuItem
                        value="pending"
                        disabled={
                          data?.status === "active" || data?.status === "banned"
                        }
                      >
                        <FormattedMessage id="status.pending" />
                      </MenuItem>
                      <MenuItem value="active">
                        {" "}
                        <FormattedMessage id="status.active" />
                      </MenuItem>
                    </SelectComponent>
                  </ColumnContainer>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} alignSelf={"end"}>
                  <RowContainer style={{ width: "100%" }} start align="center">
                    {editingUser ? (
                      <RowContainer start halfGap>
                        <DashboardButton
                          type="filled"
                          style={{ textTransform: "unset", width: "160px" }}
                          onClick={() => handleSaveUser(id)}
                        >
                          <FormattedMessage id="button.save" />
                        </DashboardButton>

                        <DashboardButton
                          type="outlined"
                          style={{ textTransform: "unset", width: "160px" }}
                          onClick={() => handleCancel()}
                        >
                          <FormattedMessage id="button.cancel" />
                        </DashboardButton>
                      </RowContainer>
                    ) : null}
                  </RowContainer>
                </Grid>
                {userStatus !== "banned" &&
                data?.status === "pending" &&
                data?.password_temporary ? (
                  <>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <>
                        {userStatus !== "banned" &&
                        data?.status === "pending" &&
                        data?.password_temporary ? (
                          <ColumnContainer minGap>
                            <Typography
                              variant="p"
                              component="p"
                              fontSize="1rem"
                              fontWeight="bold"
                              color={"var(--main-color)"}
                            >
                              <FormattedMessage id="users.temporaryPassword" />
                            </Typography>
                            <TextField
                              value={data?.password_temporary}
                              sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "var(--text-primary)",
                                  color: "var(--text-primary)",
                                  fontSize: "14px",
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      edge="end"
                                      onClick={() => {
                                        copyToClipboard(
                                          data?.password_temporary
                                        );
                                      }}
                                    >
                                      <CopyAllRounded />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </ColumnContainer>
                        ) : null}
                        <SnackbarComponent
                          open={openSnackbar}
                          duration={4000}
                          handleClose={() => setOpenSnackbar(false)}
                          message={<FormattedMessage id="snackbar.copied" />}
                        />
                      </>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} alignSelf={"end"}>
                      <RowContainer
                        style={{ width: "100%" }}
                        start
                        align="center"
                      >
                        <RowContainer start halfGap>
                          <Tooltip
                            title={
                              <FormattedMessage id="tooltip.temporaryPassword" />
                            }
                          >
                            <div>
                              <DashboardButton
                                type="filled"
                                style={{
                                  width: "160px",
                                }}
                                onClick={handleSendPassword}
                              >
                                <FormattedMessage id="button.send" />
                              </DashboardButton>
                            </div>
                          </Tooltip>
                        </RowContainer>
                        {sentPassword ? (
                          <Typography
                            variant="p"
                            component="p"
                            fontSize="14px"
                            fontWeight="bold"
                            color={"var(--main-color)"}
                          >
                            <FormattedMessage id="users.temporaryPassword.sent" />{" "}
                            <FormatDateTime value={today} />
                          </Typography>
                        ) : null}
                      </RowContainer>
                    </Grid>
                  </>
                ) : null}
              </Grid>
              {projects?.paginated_results.length > 0 ? (
                <ColumnContainer halfGap>
                  <TitleContainer>
                    <RowContainer align="center" start>
                      <RowContainer minGap start align="center">
                        <Typography variant="h4" component="h4">
                          <FormattedMessage id="users.projects.title"></FormattedMessage>
                        </Typography>
                      </RowContainer>

                      <Typography
                        cursor="pointer"
                        variant="p"
                        component="p"
                        marginTop="5px"
                        color={
                          disabledBtn
                            ? "var(--bkg-quaternary) !important"
                            : "var(--main-color) !important"
                        }
                        sx={{
                          cursor: disabledBtn ? "wait" : "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => handleReloadProjectList(id)}
                      >
                        <FormattedMessage id="users.update" />
                      </Typography>
                    </RowContainer>
                  </TitleContainer>
                  <UserProjectsList
                    tableHeaders={headers}
                    onProjectsFilterStateChange={handleFiltersChange}
                    projects={projects || []}
                    paginationData={projects?.pagination || []}
                    notFilteredSlaveProjects={
                      projects?.not_filtered_projects || []
                    }
                    refetchSlaveProjects={refetchSlaveProjects}
                    onProjectsCurrentPageChange={handleCurrentPageChange}
                    onProjectsPageChange={handlePageChange2}
                  />
                </ColumnContainer>
              ) : null}
            </>
          </ColumnContainer>

          <RowContainer center>
            {!isLoadingProjects &&
            !isErrorProjects &&
            projects?.paginated_results?.length > 0 ? (
              <Pagination
                sx={{ paddingBottom: "20px" }}
                count={projects?.pagination?.total_pages}
                page={projects?.pagination?.active_page}
                onChange={handlePageChange}
              />
            ) : null}
          </RowContainer>
        </ColumnContainer>
      ) : null}
      <CreditsModal
        className="credits"
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        defaultCredits={[50, 100, 200, 300, 500]}
        currentUserCredits={data?.credits || 0}
      />
    </ColumnContainer>
  );
};
